<template>
  <div
    id="searchFilter"
  >
    <v-row>
      <v-col cols md="6">
        <v-text-field
          :placeholder="$t('Поиск по названию, тексту, ID проекта')"
          v-model="search.name"
          required
          outlined
          dense
          clearable
        />
      </v-col>
      <v-col
        cols
        md="6"
      >
        <div class="select-def">
          <v-select
            :items="statuses"
            item-value="id"
            item-text="transName"
            v-model="search.status"
            :placeholder="$t('Статус')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
      <v-col
        cols
        md="6"
      >
        <div class="select-def">
          <v-select
            :items="views"
            item-value="id"
            item-text="transName"
            v-model="search.view"
            :placeholder="$t('Вид')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
      <v-col
        v-if="user && user.roleAdmin === true"
        cols
        md="6"
      >
        <div class="select-def">
          <v-autocomplete
            :items="developers"
            item-value="id"
            item-text="transName"
            v-model="search.developer"
            :placeholder="$t('Разработчики')"
            required
            outlined
            dense
            clearable
          >
            <template v-slot:item="{ item }">
              <v-list-item-icon class="select-def__icon">
                <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.transName }}
                </v-list-item-title>
                </v-list-item-content>
              </template>
          </v-autocomplete>
        </div>
      </v-col>
      <v-col
        v-if="user && (user.roleAdmin === true || user.roleDeveloper === true)"
        cols
        md="6"
      >
        <div class="select-def">
          <v-select
            :items="types"
            item-value="id"
            item-text="name"
            v-model="search.type"
            :placeholder="$t('Тип')"
            required
            outlined
            dense
            clearable
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="form-action" cols sm="12" md>
        <button
          class="btn btn-default blue"
          @click=";(page = 1), searchNpa()"
        >
          {{ $t('Поиск') }}
        </button>
        <button
          class="btn btn-default white"
          @click="resetNpa()"
        >
          {{ $t('Очистить') }}
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  name: "MyNpaSearch",
  props: {
    search: Object,
    developers: {
      type: [Array, Object],
      default: () => []
    },
    statuses: {
      type: [Array, Object],
      default: () => []
    },
    views: {
      type: [Array, Object],
      default: () => []
    },
    types: {
      type: [Array, Object],
      default: () => []
    },
  },
  computed: {
    listLocal: {
      get() {
        return this.developers
      }
    },
    user() {
      return this.$store.state.getUser.currentUser
    }
  },
  methods: {
    searchNpa() {
      this.$emit('search-npa', this.search)
    },
    resetNpa() {
      this.$emit('reset-npa', this.search)
    }
  }
}
</script>
